import React, { useEffect, useMemo } from 'react';
import { Center, Heading, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { useReduxDispatch } from '../../../app/store';
import chargerImg from '../../../assets/images/evse_charger.svg';
import { ArcButton } from '../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';
import { useOnboardingWizardProgress } from '../../home/useOnboardingWizardProgress';
import { selectEvChargerData, setHasVisitedRegisterScreen } from '../dashboard/evChargerSlice';

/* istanbul ignore next -- @preserve */
export const DeviceRegister = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useReduxDispatch();
  const { hasVisitedRegisterScreen } = useSelector(selectEvChargerData);
  const { needsToConfigureHardware } = useOnboardingWizardProgress();
  const { t } = useTranslation();

  useEffect(() => {
    // Updating flag so that user is not redirected to this screen from dashboard again.
    if (!hasVisitedRegisterScreen) dispatch(setHasVisitedRegisterScreen(true));
  });

  const backURL = useMemo(() => {
    const params = new URLSearchParams(location.search);
    if (needsToConfigureHardware) return `../../../first_time_hardware_configuration?direction=back`;
    return params.get('backURL') ?? `../../../home`;
  }, [needsToConfigureHardware, location.search]);

  return (
    <SlidingAnimationPageBase title={t('Common.device setup')} backURL={backURL} customNavigationDirection="forward">
      <Center flexDirection="column" px={3} textAlign="center">
        <Image data-testid="ev-charger-image" src={chargerImg} alt="Charging Station" my={4} />

        <Heading mt={2}>{t('EVSE.pair with charger')}</Heading>
        <Text data-testid="ev-setup-text" mt={1}>
          {t('EVSE.pair with charger text')}
        </Text>

        <ArcButton
          data-testid="ev-charger-continue"
          onClick={() => navigate(`../device-power-up-instructions`)}
          mt={8}
          w={'80%'}
          arcColor="#3DCD57"
        >
          {t('Common.continue')}
        </ArcButton>
      </Center>
    </SlidingAnimationPageBase>
  );
};
